import type { IDropdownChild } from "@similarweb/ui-components";
import { getDropdownChildId } from "app/pages/sales-intelligence/utils/dropdowns";

export const getDropdownChildSortingIteratee = (
    collection: Record<string | number, boolean>,
): ((child: IDropdownChild) => boolean) => {
    return (child) => {
        const id = getDropdownChildId(child);

        if (typeof id === "undefined") {return false;}

        return !collection[id];
    };
};
